export { default as Login } from './Login'
export { default as ForgotPassword } from './ForgotPassword'
export { default as EditPassword } from './EditPassword'


// WEBPACK FOOTER //
// ./src/scenes/Auth/Pages/index.js